/**
 * Created by Slava on 04.09.2024
 */

SnapshotAdapters.scene.getInfo = cleverapps.extendFunc(SnapshotAdapters.scene.getInfo, function () {
    const component = VillageSceneComponent.GetRunning();
    if (component && !component.village.location) {
        return {
            villageState: component.village.state,
            villagePlayer: component.village.getPlayer(),
            village: component.village.getInfo()
        };
    }

    return this._super();
});
